<script setup lang="ts">
import { computed } from 'vue';
import AppButton from './app-button.vue';

const emit = defineEmits(['toggle']);
const props = defineProps({
  isCollapsed: {
    type: Boolean,
    required: true,
  },
  isVisible: {
    type: Boolean,
    default: true,
  },
});

const showCollapse = computed(() => props.isVisible && !props.isCollapsed);
const showExpander = computed(() => props.isVisible && props.isCollapsed);
const onToggleMenu = () => emit('toggle', showCollapse.value ? true : showExpander.value ? false : undefined);
</script>

<template>
  <app-button
    v-if="isVisible"
    use-flat
    :outlined="false"
    severity="info"
    :icon="isCollapsed ? 'hugeicons:arrow-right-03' : 'hugeicons:arrow-left-03'"
    @click="onToggleMenu"
  />
</template>
